export const apiBaseUrl = './api/v1'
